import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ShowComponent from "Components/ShowComponent";
import Popup from "Components/Common/Pages/Popup";
import ConfigurationAPI from "api/configuration/configuration";
import DiscountAPI from "api/posapi/discount";
import LocationsAPI from "api/location/location";
import Select from "react-select";

import {
  setSaleCommissionData,
  selectedCategoryOptionName,
  addItemToTable,
  filterItem,
  updateItemPercentage,
  updateItemValueType,
  clearTable,
  removeItemFromTable,
  popUpId,
} from "store/SaleCommission";

function CreateCommission({ setRefresh, fetchData, fetchComissionData }) {
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [discountThresh, setDiscountThresh] = useState("");
  const selectInputRef = useRef();

  useEffect(() => {
    LocationsAPI.allLocationsAPI()
      .then((response) => {
        setLocations(response.data.locations);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const locationsToCreate = selectedLocation.map(({ value }) => value);

  const dispatch = useDispatch();
  const saleCommissionData = useSelector(
    (state) => state.saleCommission.saleCommissionData
  );
  const filteredProducts = useSelector(
    (state) => state.saleCommission.filteredProducts
  );
  const tableData = useSelector((state) => state.saleCommission.tableData);
  const selectedCategoryOption = useSelector(
    (state) => state.saleCommission.selectedCategoryOption
  );
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [product, setProduct] = useState([]);
  const [selectAll, setSelectAll] = useState(true);
  const [popupId, setPopupId] = useState("");

  const handleCreateSaleCommission = (e) => {
    setLoading(true);
    e.preventDefault();
    if (saleCommissionData.comissionType === "inovice") {
      ConfigurationAPI.CreateCommission({
        sale_commision_configuration: {
          value: parseInt(saleCommissionData?.Percentage),
          commision_type: saleCommissionData?.valueType,
          location_ids: locationsToCreate,
          discount_thresh: parseInt(discountThresh),
          discount_thresh_type: "percentage",
        },
      })
        .then((res) => {
          fetchComissionData();
          setLoading(false);
          toast.success(res?.data.message);
          setRefresh(true);
          dispatch(clearTable());
          dispatch(popUpId());
          selectInputRef.current.clearValue();
        })
        .catch((error) => {
          setLoading(false);
          const errorMessage = error?.response?.data.message
            ? error?.response.data.message
            : "An error occurred";
          if (error?.response?.data?.message) {
            toast.error(`Invoice Commmission Already Created`);
          }
        });
    } else {
      const productCommission = tableData.map((product) => ({
        product_id: parseInt(product.product_id, 10),
        commision_type: product.commission?.valueType,
        value: parseInt(product.commission?.Percentage, 10),
      }));

      ConfigurationAPI.productComission({
        sale_product_commision_configuration: {
          commisions: productCommission,
          location_ids: locationsToCreate,
          discount_thresh: parseInt(discountThresh),
          discount_thresh_type: "percentage",
        },
      })
        .then((res) => {
          fetchData();
          toast.success(res.data.message);
          setRefresh(true);
          dispatch(clearTable());
          dispatch(popUpId());
        })
        .catch((error) => {
          const errorMessage = error.response?.data.message
            ? error.response.data.message
            : "An error occurred";
          toast.error(`Error: ${errorMessage}`);
        });
    }
  };

  useEffect(() => {
    DiscountAPI.productsAvailable()
      .then((res) => {
        const uniqueCategories = Array.from(
          new Set(res.data.map((item) => item.category_name))
        );
        setCategories(uniqueCategories);
        setProduct(res.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const inputOnChange = (e) => {
    const { name, value } = e.target;
    if (tableData.length || saleCommissionData.valueType) {
      setPopupId("cancelCommission");
      dispatch(
        setSaleCommissionData({
          ...saleCommissionData,
          inputValue: value,
        })
      );
    } else {
      dispatch(
        setSaleCommissionData({
          ...saleCommissionData,
          [name]: value,
        })
      );
    }
  };
  const addProductToTable = (product) => {
    const productExistsInTable = tableData.some(
      (item) => item.product_id === product.product_id
    );

    if (!productExistsInTable) {
      const updatedProduct = {
        product_id: product.product_id,
        product_name: product.product_name || product.label,
        commission: {
          Percentage: saleCommissionData.Percentage || 0,
          valueType: saleCommissionData.valueType || "percentage",
        },
      };

      dispatch(addItemToTable([...tableData, updatedProduct]));
    } else {
      dispatch(
        removeItemFromTable({
          product_id: product.product_id,
        })
      );
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      const updatedProducts = filteredProducts.map((product) => ({
        ...product,
        commission: {
          Percentage: saleCommissionData?.Percentage || 0,
          valueType: saleCommissionData?.valueType || "percentage",
        },
      }));
      dispatch(addItemToTable(updatedProducts));
      setSelectAll(false);
    } else {
      dispatch(addItemToTable([]));
      setSelectAll(true);
    }
  };
  useEffect(() => {
    if (!selectedCategoryOption || selectedCategoryOption.length === 0) {
      dispatch(filterItem([]));
      setSelectAll(true);
    }
  }, [selectedCategoryOption]);

  const handleCommissionChange = (productId, value) => {
    dispatch(
      updateItemPercentage({ product_id: productId, Percentage: value })
    );
  };

  const handleTypeChange = (productId, value) => {
    dispatch(updateItemValueType({ product_id: productId, valueType: value }));
  };

  const handleCategoryChange = (selectedOptions) => {
    const selectedLabels = selectedOptions?.map(({ label, value }) => ({
      label,
      value,
    }));
    const filteredData = product.filter((item) =>
      selectedLabels.some((selected) => selected.label === item.category_name)
    );
    dispatch(selectedCategoryOptionName(selectedLabels));
    dispatch(filterItem(filteredData));
  };

  const handleSaleCommissionCreate = (e) => {
    const { name } = e.target;
    if (name === "product") {
      setPopupId("");
    } else {
      const value = saleCommissionData.inputValue;
      dispatch(clearTable());
      dispatch(
        setSaleCommissionData({
          ...saleCommissionData,
          valueType: "",
          Percentage: "",
          comissionType: value,
        })
      );
      setPopupId("");
    }
  };

  return (
    <div className="min-h-[50vh]">
      <ShowComponent condition={popupId === "cancelCommission"}>
        <Popup setPopup={() => setPopupId("")} className="w-[50%]">
          <div className="row text-center mt-4">
            <p className="col-8">
              Are you sure you want to change Commission Type
            </p>
            <button
              className="btn btn-danger bg-red  text-white p-2 mt-2 rounded-md mb-5"
              name="inovice"
              onClick={handleSaleCommissionCreate}
            >
              Yes
            </button>
            <button
              className="btn btn-success bg-green  text-white p-2 mt-2 rounded-md mb-5 ml-2"
              name="product"
              onClick={handleSaleCommissionCreate}
            >
              No
            </button>
          </div>
        </Popup>
      </ShowComponent>
      <form onSubmit={handleCreateSaleCommission}>
        <div className="w-full flex">
          <div className="form-group w-[30%]">
            <p className="font-bold mb-2">Commission Type</p>
            <select
              className="form-control"
              name="comissionType"
              value={saleCommissionData.comissionType}
              onChange={inputOnChange}
              required
            >
              <option value="">Select Commission Type</option>
              <option value="inovice">Invoice Commission</option>
              <option value="product">Per Product Commission</option>
            </select>
          </div>
          <ShowComponent
            condition={saleCommissionData.comissionType === "inovice"}
          >
            <div className="form-group ml-4 w-[30%]">
              <p className="font-bold mb-2">Value Type</p>
              <select
                className="form-control"
                name="valueType"
                value={saleCommissionData.valueType}
                onChange={inputOnChange}
                required
              >
                <option value="">Please Select Value Type</option>
                <option value="percentage">Percentage</option>
                <option value="amount">Amount</option>
              </select>
            </div>
            <div className="form-group ml-4 w-[30%]">
              <p className="font-bold mb-2">Commission Value</p>
              <input
                className="form-control"
                type="text"
                name="Percentage"
                placeholder="Enter Commission Value"
                required
                value={saleCommissionData.Percentage}
                onChange={(e) =>
                  dispatch(
                    setSaleCommissionData({
                      ...saleCommissionData,
                      Percentage: e.target.value,
                    })
                  )
                }
              />
            </div>
          </ShowComponent>
          <ShowComponent
            condition={
              saleCommissionData.comissionType === "inovice" ||
              saleCommissionData.comissionType === "product"
            }
          >
            <div className="form-group ml-4 w-[30%]">
              <p className="font-bold mb-2">Discount Value</p>
              <input
                className="form-control hideNumberArrow"
                type="number"
                placeholder="Enter Value Less Than Equal"
                value={discountThresh}
                min={0}
                required
                onChange={(e) => setDiscountThresh(e.target.value)}
              />
            </div>

            <div className="form-group ml-4 w-[30%]">
              <p className="font-bold">Location</p>
              <Select
                classNames={{
                  control: () => "form-control mt-2 overflow-auto",
                }}
                required
                ref={selectInputRef}
                value={selectedLocation.map(({ value, label }) => ({
                  value,
                  label,
                }))}
                onChange={(selectedOptions) => {
                  setSelectedLocation(selectedOptions);
                }}
                options={locations.map((value) => ({
                  value: value.id,
                  label: value.address,
                }))}
                isSearchable={true}
                isMulti={true}
              />
            </div>
          </ShowComponent>
        </div>
        <div className="flex justify-end">
          <ShowComponent
            condition={saleCommissionData.comissionType === "inovice"}
          >
            <div className="form-group w-[18%] mt-5">
              <button
                className={`btn-primary w-full ${
                  loading && "cursor-not-allowed"
                }`}
                type="submit"
              >
                Create Commission
              </button>
            </div>
          </ShowComponent>
        </div>
        <ShowComponent
          condition={saleCommissionData.comissionType === "product"}
        >
          <div className="w-full flex gap-4">
            <div className=" w-[30%] py-2">
              <div className="mb-4">Category</div>
              <Select
                required
                className="form-group"
                isMulti={true}
                value={selectedCategoryOption}
                onChange={handleCategoryChange}
                options={categories.map((category) => ({
                  value: category,
                  label: category,
                }))}
                isClearable={true}
              />
            </div>
            <div className="form-group w-[30%] py-2">
              <div className="mb-4">Search Product</div>
              <Select
                options={filteredProducts.map((obj) => ({
                  value: obj.product_name,
                  label: obj.product_name,
                  product_id: obj.product_id,
                  quantity: obj.quantity,
                }))}
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    addProductToTable(selectedOption);
                  }
                }}
              />
            </div>
          </div>
          <div>
            <div className="flex justify-between">
              <div className="lg:w-[61%] md:w-[61%] sm:w-1/2 w-full">
                <div
                  className="bg-white rounded-3xl"
                  style={{ minHeight: "40vh" }}
                >
                  <div className="">
                    <div className="flex justify-between p-4">
                      <div className="text-24  text-center">Products</div>
                      {filteredProducts.length > 0 && (
                        <div className="">
                          <button
                            className="w-[120px] btn-primary"
                            type="button"
                            onClick={handleSelectAll}
                          >
                            {filteredProducts.length === tableData.length
                              ? "Unselect All"
                              : "Select All"}
                          </button>
                        </div>
                      )}
                    </div>
                    {dataLoading ? (
                      <div className="w-full mt-9 justify-center text-center">
                        Loading...
                      </div>
                    ) : filteredProducts.length > 0 ? (
                      <div
                        className="justify-between p-2 grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-6"
                        style={{ maxHeight: "40vh", overflowY: "auto" }}
                      >
                        {filteredProducts.map((obj) => (
                          <div
                            className="sytlecreatesale sytlecreatesalegap w-full justify-between flex border-solid border-2 border-gray-400 rounded-md p-2 text-center"
                            key={obj.id}
                          >
                            <div className="w-[70%] text-center">
                              {obj.product_name}
                            </div>
                            <div className="w-[30%] text-center">
                              <input
                                type="checkbox"
                                className="w-full rounded-md text-center"
                                checked={tableData.some(
                                  (selectedProduct) =>
                                    selectedProduct.product_id ===
                                    obj.product_id
                                )}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  if (isChecked) {
                                    addProductToTable(obj);
                                  } else {
                                    dispatch(
                                      removeItemFromTable({
                                        product_id: obj.product_id,
                                      })
                                    );
                                  }
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="w-full mt-9 justify-center text-center">
                        No Selected Category
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="lg:w-[38%] md:w-[38%] w-1/3 sm:w-1/3 bg-white rounded-3xl pt-3 pb-3 pl-2 pr-1"
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                <div className="text-[#287DFD] w-full flex justify-between p-1">
                  <div className="w-[30%] flex justify-start">
                    <span>Product</span>
                  </div>
                  <div className="w-[30%]  flex justify-center">
                    <span>Commission</span>
                  </div>
                  <div className="w-[30%]  flex justify-center">
                    <span>Type</span>
                  </div>
                  <div className="w-[5%]  flex justify-center"></div>
                </div>
                {tableData.length > 0 ? (
                  <>
                    {tableData.map((product) => {
                      return (
                        <div
                          className="flex w-full justify-between p-1"
                          key={product.product_id}
                        >
                          <div className="w-[30%] ">{product.product_name}</div>
                          <div className="w-[30%]">
                            <div className="flex w-full justify-center">
                              <input
                                type="number"
                                min={0}
                                className="border w-full  border-bg-gray p-2 hideNumberArrow"
                                value={product.commission?.Percentage}
                                onChange={(e) =>
                                  handleCommissionChange(
                                    product.product_id,
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="w-[30%] ">
                            <select
                              value={product.commission?.valueType}
                              required
                              onChange={(e) =>
                                handleTypeChange(
                                  product.product_id,
                                  e.target.value
                                )
                              }
                              className="block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
                            >
                              <option value="percentage">Percentage</option>
                              <option value="amount">Amount</option>
                            </select>
                          </div>
                          <div className="w-[5%] flex  justify-center items-center">
                            <div
                              className=" w-full"
                              onClick={() =>
                                dispatch(
                                  removeItemFromTable({
                                    product_id: product.product_id,
                                  })
                                )
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="red"
                                height="16"
                                width="14"
                                viewBox="0 0 448 512"
                              >
                                <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <div className="w-full flex  mt-10 justify-center text-center">
                    No Selected Product
                  </div>
                )}
              </div>
            </div>
          </div>
        </ShowComponent>
        <ShowComponent
          condition={saleCommissionData.comissionType === "product"}
        >
          <div className="form-group w-full justify-end flex mt-5">
            <button
              className={`btn-primary w-[18%] ${
                loading && "cursor-not-allowed"
              }`}
              type="submit"
            >
              Create Commission
            </button>
          </div>
        </ShowComponent>
      </form>
    </div>
  );
}

export default CreateCommission;
